import React, { useMemo } from "react";
import { ProgressBar } from "@fluentui/react-components";
import { Info12Regular } from "@fluentui/react-icons";
import PropTypes from "prop-types";

const Progress = ({ dataItem }) => {
  const progressValue = dataItem?.Progress?.Data ?? 0;
  const completedForms = dataItem?.CompletedForms?.Data ?? 0;
  const totalForms = dataItem?.TotalForms?.Data ?? 0;
  const progressPercentage = progressValue / 100;

  const label = useMemo(
    () => `${progressValue}% (${completedForms} of ${totalForms})`,
    [progressValue, completedForms, totalForms]
  );

  return (
    <div style={{ display: "flex", width: "95%", flexDirection: "column", marginRight: "1em" }}>
      <span
        style={{
          alignSelf: "flex-end",
          fontSize: "0.85em",
          color: "#555",
          marginBottom: "0.5em",
        }}
      >
        {label}
        <Info12Regular style={{ marginLeft: "0.25em", verticalAlign: "middle" }} />
      </span>

      <ProgressBar
        style={{ width: "100%" }}
        value={progressPercentage}
      />
    </div>
  );
};

Progress.propTypes = {
  dataItem: PropTypes.shape({
    Progress: PropTypes.shape({
      Data: PropTypes.number,
    }),
    CompletedForms: PropTypes.shape({
      Data: PropTypes.number,
    }),
    TotalForms: PropTypes.shape({
      Data: PropTypes.number,
    }),
  }).isRequired,
};

export default Progress;
